import { InfoTable } from "../../../../common/components/ui/table/InfoTable";
import { useVehicleDashboardContext } from "../vehicle-dashboard/useVehicleDashboardContext";

interface VelotrackInfo {
  motoristaVinculado: string;
  ultimaComunicacao: string;
}

export function VelotrackInfo() {
  const { vehicle } = useVehicleDashboardContext();

  return (
    <InfoTable
      title="Informações da Velotrack"
      data={[
        {
          label: "Motorista vinculado",
          value: vehicle?.velotrackSettings?.nameDriver,
        },
        {
          label: "Última comunicação",
          value: vehicle?.velotrackSettings?.lastComunication,
        },
      ]}
    />
  );
}
